import "@/i18n/config";
import React, { useEffect, useState } from "react";

import {
  getCommunityMemberProfiles,
  getOnboardingChecklist,
  updateFocus,
  updateOnboardingChecklist,
} from "@/client_app/components/CommunityMemberDetails/services/FetchAPIService";
import { PrimaryButton } from "@/ui/buttons";

interface Props {
  positionId: string;
  inAdmin?: boolean;
}

interface CheckList {
  field_name: string;
  name: string;
  onboarding_checklist_id: string;
  completed: boolean;
  completed_at: string;
  order_weight: number;
}
export function Onboarding(props: Props) {
  const { positionId, inAdmin } = props;
  const [checkList, setCheckList] = useState<CheckList[]>([]);

  useEffect(() => {
    if (positionId) {
      getOnboardingChecklist(positionId, inAdmin)
        .then((response) => response.json())
        .then((data) => {
          setCheckList(data.list);
        });
    }
  }, [positionId]);

  const handleOnCheckboxChange = (
    onboarding_checklist_id: string,
    value: boolean,
    index: number
  ) => {
    setCheckList((prev) => {
      const newList = [...prev];
      newList[index].completed = value;
      return newList;
    });
    updateOnboardingChecklist({
      positionId,
      inAdmin,
      completed: value,
      onboarding_checklist_id,
    }).then((response) => response.json());
  };

  const handleOnDateChange = (
    onboarding_checklist_id: string,
    value: string,
    index: number
  ) => {
    setCheckList((prev) => {
      const newList = [...prev];
      newList[index].completed_at = value;
      return newList;
    });
    updateOnboardingChecklist({
      positionId,
      inAdmin,
      completed_at: value,
      onboarding_checklist_id,
    }).then((response) => response.json());
  };
  return (
    <div className='p-5 m-0 max-w-[800px]'>
      <p className='mb-5'>
        <strong>Onboarding Checklist</strong>
      </p>

      <table
        className='w-full text-left border-separate table-auto'
        style={{ borderSpacing: "0 24px" }}
      >
        <tbody>
          {checkList.map((item, index) => (
            <tr key={index}>
              <td>
                <input
                  disabled={inAdmin}
                  type='checkbox'
                  checked={item.completed}
                  onChange={(e) =>
                    handleOnCheckboxChange(
                      item.onboarding_checklist_id,
                      e.target.checked,
                      index
                    )
                  }
                />
              </td>
              <td>{item.name}</td>
              <td>
                <input
                  disabled={inAdmin}
                  type='date'
                  className='form-control'
                  value={item.completed_at}
                  onChange={(e) =>
                    handleOnDateChange(
                      item.onboarding_checklist_id,
                      e.target.value,
                      index
                    )
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
